import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "workbench" }
const _hoisted_2 = { class: "workbench-header" }
const _hoisted_3 = { class: "stat-section" }
const _hoisted_4 = { class: "stat-item" }
const _hoisted_5 = { class: "stat-value" }
const _hoisted_6 = { class: "stat-item" }
const _hoisted_7 = { class: "stat-value" }
const _hoisted_8 = { class: "action-section" }
const _hoisted_9 = { class: "workbench-main" }
const _hoisted_10 = { class: "main-left" }
const _hoisted_11 = { class: "desktop-list" }
const _hoisted_12 = { class: "desk-header" }
const _hoisted_13 = { class: "desk-info" }
const _hoisted_14 = { class: "desk-name" }
const _hoisted_15 = { class: "desk-points" }
const _hoisted_16 = { class: "desk-actions" }
const _hoisted_17 = { class: "desk-occupy" }
const _hoisted_18 = { class: "seats-grid" }
const _hoisted_19 = { class: "seat-num" }
const _hoisted_20 = { class: "seat-name" }
const _hoisted_21 = { class: "seat-phone" }
const _hoisted_22 = { class: "waiting-section" }
const _hoisted_23 = { class: "waiting-title" }
const _hoisted_24 = { class: "waiting-list" }
const _hoisted_25 = { class: "waiting-index" }
const _hoisted_26 = { class: "waiting-name" }
const _hoisted_27 = { class: "waiting-phone" }
const _hoisted_28 = { class: "main-right" }
const _hoisted_29 = { class: "section-header" }
const _hoisted_30 = { class: "header-right" }
const _hoisted_31 = { class: "order-list" }
const _hoisted_32 = { class: "order-header" }
const _hoisted_33 = { class: "order-seat" }
const _hoisted_34 = { class: "order-id" }
const _hoisted_35 = { class: "order-user" }
const _hoisted_36 = { class: "user-left" }
const _hoisted_37 = { class: "user-name" }
const _hoisted_38 = { class: "user-phone" }
const _hoisted_39 = { class: "user-right" }
const _hoisted_40 = {
  key: 0,
  class: "order-amount"
}
const _hoisted_41 = {
  key: 1,
  class: "order-amount points"
}
const _hoisted_42 = { class: "order-paytype" }
const _hoisted_43 = { class: "order-goods" }
const _hoisted_44 = { class: "goods-main-line" }
const _hoisted_45 = { class: "goods-name" }
const _hoisted_46 = { class: "goods-meta" }
const _hoisted_47 = {
  key: 0,
  class: "goods-spec-lines"
}
const _hoisted_48 = { class: "order-footer" }
const _hoisted_49 = { class: "order-time" }
const _hoisted_50 = { class: "footer-btns" }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { style: {"display":"flex","gap":"8px","width":"100%"} }
const _hoisted_53 = {
  key: 0,
  class: "coupon-info"
}
const _hoisted_54 = { class: "goods-detail" }
const _hoisted_55 = { class: "goods-info" }
const _hoisted_56 = { class: "goods-name" }
const _hoisted_57 = { class: "goods-desc" }
const _hoisted_58 = { class: "goods-price" }
const _hoisted_59 = { style: {"margin-top":"16px","text-align":"center"} }
const _hoisted_60 = { class: "manual-order-container" }
const _hoisted_61 = { class: "order-left" }
const _hoisted_62 = { class: "goods-section" }
const _hoisted_63 = { class: "category-list" }
const _hoisted_64 = ["onClick"]
const _hoisted_65 = { class: "goods-list" }
const _hoisted_66 = { class: "goods-info" }
const _hoisted_67 = { class: "goods-name" }
const _hoisted_68 = { class: "goods-desc" }
const _hoisted_69 = { class: "goods-price" }
const _hoisted_70 = { class: "goods-actions" }
const _hoisted_71 = {
  key: 1,
  class: "cart-count"
}
const _hoisted_72 = { class: "order-right" }
const _hoisted_73 = { class: "cart-list" }
const _hoisted_74 = { class: "item-main" }
const _hoisted_75 = { class: "item-name" }
const _hoisted_76 = { class: "item-price" }
const _hoisted_77 = { class: "item-actions" }
const _hoisted_78 = { class: "item-count" }
const _hoisted_79 = { class: "cart-total" }
const _hoisted_80 = {
  key: 0,
  class: "total-price"
}
const _hoisted_81 = {
  key: 1,
  class: "total-price points"
}
const _hoisted_82 = { style: {"text-align":"center","margin-top":"16px"} }
const _hoisted_83 = {
  key: 0,
  class: "user-info-card"
}
const _hoisted_84 = { class: "user-detail" }
const _hoisted_85 = { class: "user-name" }
const _hoisted_86 = { class: "user-phone" }
const _hoisted_87 = { class: "user-points" }
const _hoisted_88 = { class: "points-value" }

import { ref, computed, watch, onMounted, onUnmounted } from 'vue';
import { Refresh, Bell, MuteNotification, View, Hide } from '@element-plus/icons-vue';
import { useApi } from '@/hooks/useApi';
import { ElMessage, ElMessageBox } from 'element-plus';
import Decimal from 'decimal.js';
import GoodsEditorDialog from '../goods/components/goods-editor-dialog.vue';
import GoodsSpecSelectDialog from './components/goods-spec-select-dialog.vue';
import {
  buildGoodsCartKey,
  getGoodsDisplayName,
  getGoodsSpecLines,
  normalizeGoodsSpecs,
  type GoodsSpec,
  type SelectedGoodsSpec,
} from '@/utils/goodsSpecs';

interface GoodsItem {
  name: string;
  count: number;
  price?: string;
  discountPrice?: string;
  total?: string;
  isPointsExchange?: boolean | null;
  pointsPrice?: string;
  totalPoints?: string;
  selectedSpecs?: SelectedGoodsSpec[];
  specText?: string;
}

interface OrderItem {
  id: number;
  seatInfo?: string;
  goods?: GoodsItem[];
  createTime: string;
  status: string;
  price?: string;
  pointsPrice?: string;
  payType?: string;
  userInfo?: {
    avatar?: string;
    name?: string;
    phone?: string;
  };
}

// 支付方式映射
type GoodsDisplayItem = {
  isPointsExchange?: boolean | null;
  price?: string;
  pointsPrice?: string;
  total?: string;
  totalPoints?: string;
  count?: number;
  discountPrice?: string;
  selectedSpecs?: SelectedGoodsSpec[];
  specText?: string;
};

interface SeatItem {
  seatNumber: number;
  userId?: number;
  status: 'idle' | 'reserved' | 'playing';
  userInfo?: {
    name?: string;
    avatar?: string;
    phone?: string;
  };
}

interface DesktopItem {
  id: number;
  name: string;
  basePoints?: string;
  seats?: SeatItem[];
}

interface WaitingItem {
  id: number;
  userId: number;
  createTime?: string;
  userInfo?: {
    name?: string;
    avatar?: string;
    phone?: string;
  };
}

interface CategoryItem { id: number; name: string; }
interface GoodsItemFull {
  id: number;
  name: string;
  price: string;
  image?: string;
  categoryId?: number;
  description?: string;
  stock?: number;
  isPointsExchange?: boolean | null;
  pointsPrice?: string;
  specs?: GoodsSpec[];
}
interface CartItem extends GoodsItemFull {
  cartKey: string;
  goodsId: number;
  selectedSpecs: SelectedGoodsSpec[];
  specText: string;
  count: number;
}

interface UserInfo {
  id: number;
  avatar: string;
  name: string;
  phone: string;
  points: number;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const payTypeMap: Record<string, string> = {
  wechat: '微信支付',
  cash: '现金支付',
  coins: 'D币支付',
  points: '积分支付',
  coupon: '券兑换',
  other: '其他',
};

const getPayTypeName = (payType?: string) => {
  if (!payType) {
    return '-';
  }
  return payTypeMap[payType] || payType;
};

const formatMoney = (value?: string | number) => new Decimal(value || 0).toFixed(2);

const formatPoints = (value?: string | number) => new Decimal(value || 0).toString();

const hasMoneyAmount = (value?: string | number) => new Decimal(value || 0).gt(0);

const hasPointsAmount = (value?: string | number) => new Decimal(value || 0).gt(0);

const isPointsGoods = (goods: GoodsDisplayItem) => Boolean(goods.isPointsExchange) || hasPointsAmount(goods.totalPoints || goods.pointsPrice);

const getGoodsUnitDisplay = (goods: GoodsDisplayItem) => {
  if (isPointsGoods(goods)) {
    return `${formatPoints(goods.pointsPrice || goods.price)} 积分`;
  }
  return `¥${formatMoney(goods.discountPrice || goods.price)}`;
};

const getGoodsTotalDisplay = (goods: GoodsDisplayItem) => {
  if (isPointsGoods(goods)) {
    const totalPoints = goods.totalPoints
      || new Decimal(goods.pointsPrice || goods.price || 0)
        .times(goods.count || 0)
        .toString();
    return `${formatPoints(totalPoints)} 积分`;
  }
  const totalPrice = goods.total
    || new Decimal(goods.price || 0)
      .times(goods.count || 0)
      .toString();
  return `¥${formatMoney(totalPrice)}`;
};

const getFullUrl = (url: string) => {
  if (!url) {
    return '';
  }
  if (url.startsWith('http')) {
    return url;
  }
  return useApi().baseUrl + url;
};

const todayIncome = ref('0.00');
const todayOrderCount = ref(0);
const statVisible = ref(false);
const desktopLoading = ref(false);
const orderLoading = ref(false);
const desktopList = ref<DesktopItem[]>([]);
const orderDeskList = ref<DesktopItem[]>([]);
const pendingOrders = ref<OrderItem[]>([]);
const waitingList = ref<WaitingItem[]>([]);

// 上桌对话框
const sitDownDialogVisible = ref(false);
const sitDownForm = ref({
  desktopId: 0, seatNumber: 0, userId: undefined as number | undefined, points: 0, isReserved: false, userName: '',
});

// 候桌上桌对话框
const waitingSitDlgVisible = ref(false);
const waitingSitForm = ref({
  userId: 0, desktopId: undefined as number | undefined, seatNumber: undefined as number | undefined,
  points: 0, userName: '', waitingId: 0,
});

// 积分审核弹窗
const depositDlgVisible = ref(false);
const withdrawDlgVisible = ref(false);
const depositList = ref<any[]>([]);
const withdrawList = ref<any[]>([]);
const depositPage = ref(1);
const depositTotal = ref(0);
const withdrawPage = ref(1);
const withdrawTotal = ref(0);

// 核销券弹窗
const verifyCouponDlgVisible = ref(false);
const couponId = ref('');
const couponInfo = ref<any>(null);
const couponLoading = ref(false);
const verifyLoading = ref(false);
const verifyCouponForm = ref({
  desktopId: undefined as number | undefined,
  seatNumber: undefined as number | undefined,
});

// 手动下单弹窗
const manualOrderDlgVisible = ref(false);
const manualOrderLoading = ref(false);
const manualOrderForm = ref({
  userId: undefined as number | undefined,
  desktopId: undefined as number | undefined,
  payType: 'cash' as string,
  receivedAmount: 0,
  remark: '',
});
const userSearchLoading = ref(false);
const userOptions = ref<{ label: string; value: number; openid: string }[]>([]);

// 会员积分调整
const adjustPointsDlgVisible = ref(false);
const adjustPointsLoading = ref(false);
const adjustPointsSearchLoading = ref(false);
const adjustPointsUserOptions = ref<{ label: string; value: number; userInfo: UserInfo }[]>([]);
const selectedUserInfo = ref<UserInfo | null>(null);
const adjustPointsForm = ref({
  userId: undefined as number | undefined,
  type: 'add' as 'add' | 'reduce',
  amount: 1,
  reason: '',
});

const categoryList = ref<CategoryItem[]>([]);
const goodsList = ref<GoodsItemFull[]>([]);
const currentCategoryIdx = ref(0);
const cart = ref<Map<string, CartItem>>(new Map());
const specDialogVisible = ref(false);
const specDialogGoods = ref<GoodsItemFull | undefined>();
const specDialogSpecs = ref<SelectedGoodsSpec[]>([]);

const filteredGoodsList = computed(() => {
  const category = categoryList.value[currentCategoryIdx.value];
  if (!category) {
    return goodsList.value;
  }
  return goodsList.value.filter((goodsItem) => goodsItem.categoryId === category.id);
});

const cartItems = computed(() => Array.from(cart.value.values()));
const cartMoneyTotal = computed(() => {
  let total = new Decimal(0);
  cart.value.forEach((item) => {
    if (!item.isPointsExchange) {
      total = total.plus(new Decimal(item.price || 0).times(item.count));
    }
  });
  return total.toFixed(2);
});
const cartPointsTotal = computed(() => {
  let total = new Decimal(0);
  cart.value.forEach((item) => {
    if (item.isPointsExchange) {
      total = total.plus(new Decimal(item.pointsPrice || item.price || 0).times(item.count));
    }
  });
  return total.toString();
});
const manualPayTypeOptions = computed(() => {
  if (!hasMoneyAmount(cartMoneyTotal.value) && hasPointsAmount(cartPointsTotal.value)) {
    return [{ label: '积分支付', value: 'points' }];
  }
  return [
    { label: '现金', value: 'cash' },
    { label: '其他', value: 'other' },
  ];
});

// 监听购物车合计变化，自动更新实收金额与默认支付方式
watch(cartMoneyTotal, (newVal) => {
  manualOrderForm.value.receivedAmount = Number(newVal);
  if (!hasMoneyAmount(newVal) && hasPointsAmount(cartPointsTotal.value)) {
    manualOrderForm.value.payType = 'points';
    return;
  }
  if (manualOrderForm.value.payType === 'points') {
    manualOrderForm.value.payType = 'cash';
  }
});

watch(cartPointsTotal, (newVal) => {
  if (!hasMoneyAmount(cartMoneyTotal.value) && hasPointsAmount(newVal)) {
    manualOrderForm.value.payType = 'points';
    return;
  }
  if (manualOrderForm.value.payType === 'points') {
    manualOrderForm.value.payType = 'cash';
  }
});

const getCartCount = (goodsId: number) => cartItems.value
  .filter((item) => item.goodsId === goodsId)
  .reduce((total, item) => total + item.count, 0);

const addResolvedGoodsToCart = (goods: GoodsItemFull, selectedSpecs: SelectedGoodsSpec[], specText: string) => {
  const cartKey = buildGoodsCartKey(goods.id, selectedSpecs);
  const existing = cart.value.get(cartKey);
  const currentCount = existing?.count || 0;
  const stock = goods.stock ?? 999;
  if (currentCount >= stock) {
    ElMessage.warning(`${goods.name} 库存不足`);
    return;
  }
  if (existing) {
    existing.count++;
  } else {
    cart.value.set(cartKey, {
      ...goods,
      cartKey,
      goodsId: goods.id,
      selectedSpecs,
      specText,
      count: 1,
    });
  }
  cart.value = new Map(cart.value);
};

const openSpecDialog = (goods: GoodsItemFull, initialSelectedSpecs: SelectedGoodsSpec[] = []) => {
  specDialogGoods.value = goods;
  specDialogSpecs.value = initialSelectedSpecs;
  specDialogVisible.value = true;
};

const handleSpecDialogConfirm = ({ selectedSpecs, specText }: { selectedSpecs: SelectedGoodsSpec[]; specText: string }) => {
  if (!specDialogGoods.value) {
    return;
  }
  addResolvedGoodsToCart(specDialogGoods.value, selectedSpecs, specText);
};

const addToCart = (goods: GoodsItemFull) => {
  if (normalizeGoodsSpecs(goods.specs).length > 0) {
    openSpecDialog(goods);
    return;
  }
  addResolvedGoodsToCart(goods, [], '');
};

const increaseCartItem = (goods: CartItem) => {
  if (normalizeGoodsSpecs(goods.specs).length > 0) {
    openSpecDialog(goods, goods.selectedSpecs);
    return;
  }
  addResolvedGoodsToCart(goods, goods.selectedSpecs, goods.specText);
};

const decreaseCartItem = (cartKey: string) => {
  const existing = cart.value.get(cartKey);
  if (!existing) {
    return;
  }
  if (existing.count > 1) {
    existing.count--;
  } else {
    cart.value.delete(cartKey);
  }
  cart.value = new Map(cart.value);
};

const removeFromCart = (goods: GoodsItemFull) => {
  const matchedItems = cartItems.value.filter((item) => item.goodsId === goods.id);
  if (matchedItems.length === 0) {
    return;
  }
  if (normalizeGoodsSpecs(goods.specs).length > 0 && matchedItems.length > 1) {
    ElMessage.info('多规格商品请在右侧购物车中调整数量');
    return;
  }
  decreaseCartItem(matchedItems[0].cartKey);
};

// 声音控制
const soundEnabled = ref(true);
const orderAudio = new Audio('/new_order.mp3');
let refreshTimer: ReturnType<typeof setInterval> | null = null;
let lastOrderIds = new Set<number>();
let isFirstLoad = true;

// 播放新订单提示音
const playNewOrderSound = () => {
  if (soundEnabled.value) {
    orderAudio.currentTime = 0;
    orderAudio.play().catch(() => {
      // 忽略自动播放限制错误
    });
  }
};

// 检查是否有新订单
const checkNewOrders = (orders: OrderItem[]) => {
  const currentIds = new Set(orders.map((item) => item.id));
  // 首次加载只记录ID，不判断为新订单
  if (isFirstLoad) {
    lastOrderIds = currentIds;
    isFirstLoad = false;
    return false;
  }
  let hasNew = false;
  for (const orderId of currentIds) {
    if (!lastOrderIds.has(orderId)) {
      hasNew = true;
      break;
    }
  }
  lastOrderIds = currentIds;
  return hasNew;
};

// 获取已占用座位数
const getOccupiedCount = (desk: DesktopItem) => {
  if (!desk.seats || desk.seats.length === 0) {
    return 0;
  }
  return desk.seats.filter((seat) => seat.status !== 'idle').length;
};

// 获取座位状态class: idle(空闲), reserved(已预约), playing(游戏中)
const getSeatStatus = (desk: DesktopItem, seatNum: number) => {
  const seat = desk.seats?.find((item) => item.seatNumber === seatNum);
  if (!seat) {
    return 'idle';
  }
  return seat.status;
};

// 获取座位用户名
const getSeatUserName = (desk: DesktopItem, seatNum: number) => {
  const seat = desk.seats?.find((item) => item.seatNumber === seatNum);
  if (!seat || seat.status === 'idle') {
    return '';
  }
  return seat.userInfo?.name || '-';
};

// 获取座位头像
const getSeatAvatar = (desk: DesktopItem, seatNum: number) => {
  const seat = desk.seats?.find((item) => item.seatNumber === seatNum);
  if (!seat || seat.status === 'idle') {
    return '';
  }
  const avatar = seat.userInfo?.avatar || '';
  if (!avatar || avatar.startsWith('http')) {
    return avatar;
  }
  return useApi().baseUrl + avatar;
};

// 获取座位手机号
const getSeatPhone = (desk: DesktopItem, seatNum: number) => {
  const seat = desk.seats?.find((item) => item.seatNumber === seatNum);
  if (!seat || seat.status === 'idle') {
    return '';
  }
  return seat.userInfo?.phone || '-';
};

// 获取今日统计
const fetchTodayStats = async() => {
  try {
    const res = await useApi().statisticsApi.getTodayStatisticsstatistics();
    todayIncome.value = res.data.data?.totalIncome || '0.00';
    todayOrderCount.value = res.data.data?.totalOrders || 0;
  } catch {
    todayIncome.value = '0.00';
    todayOrderCount.value = 0;
  }
};

// 获取桌面列表
const fetchDesktopList = async() => {
  try {
    desktopLoading.value = true;
    const res = await useApi().desktopApi.pageDesktopdesktop({
      conditions: { desktopType: 'reservation' as any },
      pageQuery: { page: 0, pageSize: 100 },
    });
    desktopList.value = (res.data.data?.data || []) as DesktopItem[];
  } finally {
    desktopLoading.value = false;
  }
};

// 获取点单桌列表（desktopType包含order_desk）
const fetchOrderDeskList = async() => {
  try {
    const res = await useApi().desktopApi.pageDesktopdesktop({
      conditions: { desktopType: 'order_desk' as any },
      pageQuery: { page: 0, pageSize: 100 },
    });
    orderDeskList.value = (res.data.data?.data || []) as DesktopItem[];
  } catch {
    orderDeskList.value = [];
  }
};

// 获取待出餐订单
const fetchPendingOrders = async(checkSound = false) => {
  try {
    orderLoading.value = true;
    const res = await useApi().billApi.listWaitingBillbill();
    const orders = (res.data.data || []) as OrderItem[];
    // 检测新订单并播放提示音
    if (checkSound && checkNewOrders(orders)) {
      playNewOrderSound();
    }
    pendingOrders.value = orders;
  } finally {
    orderLoading.value = false;
  }
};

// 获取候桌列表
const fetchWaitingList = async() => {
  try {
    const res = await useApi().waitingDeskApi.listWaitingDeskwaitingDesk({
      conditions: {},
    });
    waitingList.value = (res.data.data || []) as WaitingItem[];
  } catch {
    waitingList.value = [];
  }
};

// 刷新数据
const handleRefresh = () => {
  fetchTodayStats();
  fetchWaitingList();
  fetchDesktopList();
  fetchPendingOrders();
};

// 打开核销券弹窗
const handleVerifyCoupon = () => {
  couponId.value = '';
  couponInfo.value = null;
  verifyCouponForm.value = { desktopId: undefined, seatNumber: undefined };
  verifyCouponDlgVisible.value = true;
};

// 关闭核销券弹窗
const closeVerifyCouponDlg = () => {
  verifyCouponDlgVisible.value = false;
  couponId.value = '';
  couponInfo.value = null;
};

// 查询券
const handleQueryCoupon = async() => {
  if (!couponId.value) {
    ElMessage.warning('请输入券码');
    return;
  }
  couponLoading.value = true;
  try {
    const res = await useApi().couponApi.findCouponByIdcoupon({ couponId: Number(couponId.value) });
    if (res.data.data) {
      couponInfo.value = res.data.data;
    } else {
      ElMessage.warning('未找到该券');
      couponInfo.value = null;
    }
  } catch {
    ElMessage.error('查询失败');
    couponInfo.value = null;
  } finally {
    couponLoading.value = false;
  }
};

// 确认核销
const handleVerifyCouponSubmit = async() => {
  if (!couponInfo.value) {
    return;
  }
  // 有商品时需要选择桌和座位
  if (couponInfo.value.goods) {
    if (!verifyCouponForm.value.desktopId) {
      ElMessage.warning('请选择桌');
      return;
    }
    if (!verifyCouponForm.value.seatNumber) {
      ElMessage.warning('请选择座位');
      return;
    }
  }
  verifyLoading.value = true;
  try {
    await useApi().couponApi.verifyCouponcoupon({
      couponId: couponInfo.value.id,
      desktopId: verifyCouponForm.value.desktopId,
      seatNumber: verifyCouponForm.value.seatNumber,
    });
    ElMessage.success('核销成功');
    verifyCouponDlgVisible.value = false;
    couponInfo.value = null;
    couponId.value = '';
    verifyCouponForm.value = { desktopId: undefined, seatNumber: undefined };
    handleRefresh();
  } catch {
    ElMessage.error('核销失败');
  } finally {
    verifyLoading.value = false;
  }
};

// 获取存积分申请列表
const fetchDepositList = async() => {
  try {
    const res = await useApi().pointsApplyApi.pagePointsApplypointsApply({
      conditions: { type: 'deposit', status: 'pending' },
      pageQuery: { page: depositPage.value - 1, pageSize: 10 },
    });
    depositList.value = res.data.data?.data || [];
    depositTotal.value = res.data.data?.total || 0;
  } catch {
    depositList.value = []; depositTotal.value = 0;
  }
};

// 获取取积分申请列表
const fetchWithdrawList = async() => {
  try {
    const res = await useApi().pointsApplyApi.pagePointsApplypointsApply({
      conditions: { type: 'withdraw', status: 'pending' },
      pageQuery: { page: withdrawPage.value - 1, pageSize: 10 },
    });
    withdrawList.value = res.data.data?.data || [];
    withdrawTotal.value = res.data.data?.total || 0;
  } catch {
    withdrawList.value = []; withdrawTotal.value = 0;
  }
};

// 打开存积分审核弹窗
const handleDepositAudit = async() => {
  await fetchDepositList();
  depositDlgVisible.value = true;
};

// 打开取积分审核弹窗
const handleWithdrawAudit = async() => {
  await fetchWithdrawList();
  withdrawDlgVisible.value = true;
};

// 审批操作
const handleApprove = async(row: any, status: 'approved' | 'rejected') => {
  const statusText = status === 'approved' ? '通过' : '拒绝';
  try {
    let convertType: 'points' | 'coins' | undefined;

    // 存积分审核通过时，检查是否超过限额
    if (status === 'approved' && row.type === 'deposit') {
      const ruleRes = await useApi().pointsRuleApi.getPointsRulepointsRule();
      const limitPoints = Number(ruleRes.data.data?.limitPoints || 0);
      const applyPoints = Number(row.points || 0);

      if (limitPoints > 0 && applyPoints > limitPoints) {
        // 超过限额，需要选择转换类型
        const result = await ElMessageBox.confirm(
          `申请积分 ${applyPoints} 超过1:1兑换上限 ${limitPoints}，超出部分需要选择转换类型`,
          '选择转换类型',
          {
            distinguishCancelAndClose: true,
            confirmButtonText: '转换为积分',
            cancelButtonText: '转换为D币',
          },
        )
          .then(() => 'points')
          .catch((action) => (action === 'cancel' ? 'coins' : null));

        // 用户关闭弹窗
        if (!result) {
          return;
        }
        convertType = result as 'points' | 'coins';
      }
    }

    // 二次确认
    try {
      await ElMessageBox.confirm(
        `确定要${statusText}该申请吗？`,
        '确认操作',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        },
      );
    } catch (error) {
      console.log(error);
      return;
    }

    // 调用接口
    if (convertType) {
      await useApi().pointsApplyApi.approvePointsApplypointsApply(row.id, {
        status,
        convertType,
      });
    } else {
      await useApi().pointsApplyApi.approvePointsApplypointsApply(row.id, { status });
    }

    ElMessage.success(`已${statusText}`);
    // 刷新对应列表
    if (row.type === 'deposit') {
      await fetchDepositList();
    } else {
      await fetchWithdrawList();
    }
  } catch {
    ElMessage.error('操作失败');
  }
};

const handleAdjustPoints = () => {
  adjustPointsForm.value = {
    userId: undefined,
    type: 'add',
    amount: 1,
    reason: '',
  };
  selectedUserInfo.value = null;
  adjustPointsUserOptions.value = [];
  adjustPointsDlgVisible.value = true;
};

// 搜索用户（积分调整用）
const searchUsersForPoints = async(query: string) => {
  if (!query) {
    adjustPointsUserOptions.value = [];
    return;
  }
  adjustPointsSearchLoading.value = true;
  try {
    const res = await useApi().userApi.pageUsersuser({
      conditions: { meta: `phone": "%${query}%"` as any },
      pageQuery: { page: 0, pageSize: 10 },
    });
    adjustPointsUserOptions.value = res.data.data?.data?.map((item: any) => ({
      label: `${item.meta?.name || '-'}(${item.meta?.phone || '-'})`,
      value: item.id,
      userInfo: {
        id: item.id,
        avatar: item.meta?.avatar ? getFullUrl(item.meta.avatar) : '',
        name: item.meta?.name || '',
        phone: item.meta?.phone || '',
        points: item.meta?.points || 0,
      },
    })) || [];
  } catch {
    adjustPointsUserOptions.value = [];
  } finally {
    adjustPointsSearchLoading.value = false;
  }
};

// 选择用户后显示信息
const handleSelectUserForPoints = (userId: number) => {
  const user = adjustPointsUserOptions.value.find((item) => item.value === userId);
  selectedUserInfo.value = user?.userInfo || null;
};

// 提交积分调整
const submitAdjustPoints = async() => {
  if (!adjustPointsForm.value.userId) {
    ElMessage.warning('请选择用户');
    return;
  }
  if (!adjustPointsForm.value.amount || adjustPointsForm.value.amount < 1) {
    ElMessage.warning('请输入有效的积分值');
    return;
  }
  if (!adjustPointsForm.value.reason) {
    ElMessage.warning('请输入调整原因');
    return;
  }
  const amount = adjustPointsForm.value.type === 'add'
    ? String(adjustPointsForm.value.amount)
    : String(-adjustPointsForm.value.amount);
  adjustPointsLoading.value = true;
  try {
    await useApi().userApi.changePointsuser({
      userId: adjustPointsForm.value.userId,
      amount,
      reason: adjustPointsForm.value.reason,
    });
    ElMessage.success('积分调整成功');
    adjustPointsDlgVisible.value = false;
  } catch {
    ElMessage.error('积分调整失败');
  } finally {
    adjustPointsLoading.value = false;
  }
};

// 搜索用户
const searchUsers = async(query: string) => {
  if (!query) {
    userOptions.value = [];
    return;
  }
  userSearchLoading.value = true;
  try {
    const res = await useApi().userApi.pageUsersuser({
      conditions: { meta: `phone": "%${query}%"` as any },
      pageQuery: { page: 0, pageSize: 10 },
    });
    userOptions.value = res.data.data?.data?.map((item: any) => ({
      label: `${item.meta?.name || '-'}(${item.meta?.phone || '-'})`,
      value: item.id,
      openid: item.username || '',
    })) || [];
  } catch {
    userOptions.value = [];
  } finally {
    userSearchLoading.value = false;
  }
};

// 获取分类列表
const fetchCategoryList = async() => {
  try {
    const res = await useApi().categoryApi.listCategorycategory({ conditions: { isShow: true } });
    categoryList.value = res.data.data?.map((item: any) => ({ id: item.id, name: item.name })) || [];
  } catch {
    categoryList.value = [];
  }
};

// 获取商品列表
const fetchGoodsList = async() => {
  try {
    const res = await useApi().goodsApi.listGoodsgoods({ conditions: {} });
    goodsList.value = res.data.data?.map((item: any) => ({
      id: item.id,
      name: item.name,
      price: item.price || '0',
      pointsPrice: item.isPointsExchange ? (item.price || '0') : '0',
      image: item.image,
      categoryId: item.categoryId,
      description: item.description || '',
      stock: item.stock ?? 999,
      isPointsExchange: item.isPointsExchange ?? null,
      specs: item.specs || [],
    })) || [];
  } catch {
    goodsList.value = [];
  }
};

// 打开手动下单弹窗
const handleManualOrder = async() => {
  manualOrderForm.value = {
    userId: undefined,
    desktopId: undefined,
    payType: 'cash',
    receivedAmount: 0,
    remark: '',
  };
  cart.value = new Map();
  currentCategoryIdx.value = 0;
  userOptions.value = [];
  await Promise.all([fetchCategoryList(), fetchGoodsList(), fetchOrderDeskList()]);
  manualOrderDlgVisible.value = true;
};

// 提交手动订单
const submitManualOrder = async() => {
  if (!manualOrderForm.value.userId) {
    ElMessage.warning('请选择用户');
    return;
  }
  if (!manualOrderForm.value.desktopId) {
    ElMessage.warning('请选择桌');
    return;
  }
  if (cart.value.size === 0) {
    ElMessage.warning('请选择商品');
    return;
  }
  // 从 userOptions 获取 openid
  const selectedUser = userOptions.value.find((item) => item.value === manualOrderForm.value.userId);
  const openid = selectedUser?.openid || '';

  const desk = orderDeskList.value.find((item) => item.id === manualOrderForm.value.desktopId);
  const seatInfo = desk?.name || '';
  const goodsArray = cartItems.value.map((item) => ({
    id: item.goodsId,
    name: item.name,
    price: item.price,
    pointsPrice: item.isPointsExchange ? (item.pointsPrice || item.price) : '0',
    image: item.image,
    description: item.description,
    isPointsExchange: item.isPointsExchange ?? false,
    selectedSpecs: item.selectedSpecs,
    specText: item.specText,
    count: item.count,
    total: item.isPointsExchange ? '0.00' : new Decimal(item.price || 0)
      .times(item.count)
      .toFixed(2),
    totalPoints: item.isPointsExchange
      ? new Decimal(item.pointsPrice || item.price || 0)
        .times(item.count)
        .toString()
      : '0',
  }));

  const billPrice = hasMoneyAmount(cartMoneyTotal.value)
    ? new Decimal(manualOrderForm.value.receivedAmount || 0).toFixed(2)
    : '0.00';
  const billPointsPrice = cartPointsTotal.value;
  const hasMoneyPayment = hasMoneyAmount(cartMoneyTotal.value);
  const hasPointsPayment = hasPointsAmount(cartPointsTotal.value);
  const { payType: selectedPayType } = manualOrderForm.value;
  let payType = selectedPayType;
  if (hasMoneyPayment) {
    payType = selectedPayType;
  } else if (hasPointsPayment) {
    payType = 'points';
  }

  manualOrderLoading.value = true;
  try {
    await useApi().billApi.addBillbill({
      billAdminVo: {
        name: '手动下单',
        price: billPrice,
        pointsPrice: billPointsPrice,
        payType: payType as any,
        remark: manualOrderForm.value.remark || undefined,
        seatInfo,
        goods: goodsArray,
        billType: 'order',
        userId: manualOrderForm.value.userId,
      },
      openid,
    });
    ElMessage.success('下单成功');
    manualOrderDlgVisible.value = false;
    handleRefresh();
  } catch {
    ElMessage.error('下单失败');
  } finally {
    manualOrderLoading.value = false;
  }
};

// 获取某桌可用座位
const getAvailableSeats = (desktopId: number) => {
  const desk = desktopList.value.find((item) => item.id === desktopId);
  if (!desk) {
    return [];
  }
  const occupiedSet = desk.seats?.filter((st) => st.status !== 'idle').map((st) => st.seatNumber) || [];
  return [1, 2, 3, 4, 5, 6, 7, 8, 9].filter((num) => !occupiedSet.includes(num));
};

// 获取座位对应的 userId
const getSeatUserId = (desk: DesktopItem, seatNum: number) => desk.seats?.find((st) => st.seatNumber === seatNum)?.userId || 0;

// 打开上桌对话框（从座位点击）
const openSitDownDialog = (desk: DesktopItem, seatNum: number) => {
  const status = getSeatStatus(desk, seatNum);
  const isReserved = status === 'reserved';
  const seat = desk.seats?.find((st) => st.seatNumber === seatNum);
  sitDownForm.value = {
    desktopId: desk.id, seatNumber: seatNum,
    userId: isReserved ? (seat?.userId || undefined) : undefined,
    points: Number(desk.basePoints) || 0,
    isReserved,
    userName: isReserved ? (seat?.userInfo?.name || '-') : '',
  };
  sitDownDialogVisible.value = true;
};

// 执行上桌
const handleSitDown = async() => {
  const { desktopId, seatNumber, userId, points } = sitDownForm.value;
  if (!userId) {
    ElMessage.warning('请选择用户'); return;
  }
  try {
    await useApi().desktopApi.sitDowndesktop({ desktopId, seatNumber, userId, points: String(points) });
    ElMessage.success('上桌成功');
    sitDownDialogVisible.value = false;
    fetchDesktopList();
    fetchWaitingList();
  } catch {
    ElMessage.error('操作失败');
  }
};

// 执行离开
const handleStandUp = (desk: DesktopItem, seatNum: number) => {
  const userId = getSeatUserId(desk, seatNum);
  ElMessageBox.confirm('确定让该用户离开座位吗？', '确认离开', { type: 'warning' }).then(async() => {
    try {
      await useApi().desktopApi.standUpdesktop({ desktopId: desk.id, seatNumber: seatNum, userId });
      ElMessage.success('已离开');
      fetchDesktopList();
    } catch {
      ElMessage.error('操作失败');
    }
  })
    .catch(() => undefined);
};

// 打开候桌上桌对话框
const openWaitingSitDownDialog = (item: WaitingItem) => {
  waitingSitForm.value = {
    userId: item.userId, desktopId: undefined, seatNumber: undefined, points: 0,
    userName: `${item.userInfo?.name || '-'} (${item.userInfo?.phone || '-'})`,
    waitingId: item.id,
  };
  waitingSitDlgVisible.value = true;
};

// 执行候桌上桌
const handleWaitingSitDown = async() => {
  const { desktopId, seatNumber, userId, points } = waitingSitForm.value;
  if (!desktopId || !seatNumber) {
    ElMessage.warning('请选择桌子和座位'); return;
  }
  try {
    await useApi().desktopApi.sitDowndesktop({ desktopId, seatNumber, userId, points: String(points) });
    ElMessage.success('上桌成功');
    waitingSitDlgVisible.value = false;
    fetchDesktopList();
    fetchWaitingList();
  } catch {
    ElMessage.error('操作失败');
  }
};

// 清空座位
const handleClearSeats = (desk: DesktopItem) => {
  ElMessageBox.confirm(
    `确定要清空 ${desk.name} 的所有座位吗？`,
    '确认清空',
    { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' },
  ).then(async() => {
    try {
      await useApi().desktopApi.updateDesktopdesktop({ desktopAdminVo: { id: desk.id, seats: [] } });
      ElMessage.success('座位已清空');
      fetchDesktopList();
    } catch {
      ElMessage.error('操作失败');
    }
  });
};

const handleCancelOrder = (order: OrderItem) => {
  ElMessageBox.prompt('请输入取消原因', '取消订单', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    inputPlaceholder: '请输入取消原因',
  }).then(async({ value }) => {
    try {
      await useApi().billApi.cancelBillbill({ billId: order.id, reason: value || '管理员取消' });
      ElMessage.success('订单已取消');
      fetchPendingOrders();
    } catch {
      ElMessage.error('取消失败');
    }
  });
};

const handleComplete = (order: OrderItem) => {
  ElMessageBox.confirm('确定已完成出餐？', '完成出餐', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'info',
  }).then(async() => {
    try {
      await useApi().billApi.completeOrderbill({ billId: order.id });
      ElMessage.success('出餐完成');
      fetchPendingOrders();
    } catch {
      ElMessage.error('操作失败');
    }
  });
};

const autoRefresh = () => {
  fetchTodayStats();
  fetchWaitingList();
  fetchDesktopList();
  fetchPendingOrders(true);
};

const startRefreshTimer = () => {
  if (refreshTimer) {
    clearInterval(refreshTimer);
  }
  refreshTimer = setInterval(autoRefresh, 5000);
};
const stopRefreshTimer = () => {
  if (refreshTimer) {
    clearInterval(refreshTimer);
  }
};

onMounted(() => {
  handleRefresh();
  startRefreshTimer();
});
onUnmounted(() => {
  stopRefreshTimer();
});

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[32] || (_cache[32] = _createElementVNode("div", { class: "stat-label" }, "今日收入(小程序支付)", -1)),
          _createElementVNode("div", _hoisted_5, "¥ " + _toDisplayString(statVisible.value ? todayIncome.value : '****'), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[33] || (_cache[33] = _createElementVNode("div", { class: "stat-label" }, "今日订单", -1)),
          _createElementVNode("div", _hoisted_7, _toDisplayString(statVisible.value ? todayOrderCount.value : '****'), 1)
        ]),
        _createElementVNode("div", {
          class: "stat-toggle",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (statVisible.value = !statVisible.value))
        }, [
          _createVNode(_component_el_icon, { size: 18 }, {
            default: _withCtx(() => [
              (statVisible.value)
                ? (_openBlock(), _createBlock(_unref(View), { key: 0 }))
                : (_openBlock(), _createBlock(_unref(Hide), { key: 1 }))
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_el_button, {
          type: "warning",
          onClick: handleVerifyCoupon
        }, {
          default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
            _createTextVNode(" 核销券 ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "success",
          onClick: handleDepositAudit
        }, {
          default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
            _createTextVNode(" 存积分审核 ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "danger",
          onClick: handleWithdrawAudit
        }, {
          default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
            _createTextVNode(" 取积分审核 ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleAdjustPoints
        }, {
          default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
            _createTextVNode(" 会员积分调整 ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_button, { onClick: handleRefresh }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(Refresh))
              ]),
              _: 1
            }),
            _cache[38] || (_cache[38] = _createTextVNode(" 刷新 ", -1))
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _cache[45] || (_cache[45] = _createElementVNode("div", { class: "section-header" }, [
          _createElementVNode("h3", null, "桌面管理")
        ], -1)),
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(desktopList.value, (desk) => {
            return (_openBlock(), _createElementBlock("div", {
              key: desk.id,
              class: "desktop-card"
            }, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(desk.name), 1),
                  _createElementVNode("span", _hoisted_15, "基础积分：" + _toDisplayString(desk.basePoints || '0'), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_el_button, {
                    size: "small",
                    style: {"margin-right":"8px"},
                    onClick: ($event: any) => (handleClearSeats(desk))
                  }, {
                    default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                      _createTextVNode(" 一键清空座位 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createElementVNode("span", _hoisted_17, _toDisplayString(getOccupiedCount(desk)) + "/9", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(9, (seatNum) => {
                  return _createElementVNode("div", {
                    key: seatNum,
                    class: _normalizeClass(["seat-item", getSeatStatus(desk, seatNum)])
                  }, [
                    (getSeatStatus(desk, seatNum) === 'idle')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("span", _hoisted_19, _toDisplayString(seatNum), 1),
                          _cache[41] || (_cache[41] = _createElementVNode("span", { class: "seat-label" }, "空闲", -1)),
                          _createVNode(_component_el_button, {
                            size: "small",
                            type: "primary",
                            text: "",
                            onClick: ($event: any) => (openSitDownDialog(desk, seatNum))
                          }, {
                            default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                              _createTextVNode("上桌", -1)
                            ]))]),
                            _: 1
                          }, 8, ["onClick"])
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createVNode(_component_el_avatar, {
                            size: 28,
                            src: getSeatAvatar(desk, seatNum)
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(getSeatUserName(desk, seatNum).charAt(0)), 1)
                            ]),
                            _: 2
                          }, 1032, ["src"]),
                          _createElementVNode("span", _hoisted_20, _toDisplayString(getSeatUserName(desk, seatNum)), 1),
                          _createElementVNode("span", _hoisted_21, _toDisplayString(getSeatPhone(desk, seatNum)), 1),
                          _createElementVNode("span", {
                            class: _normalizeClass(["seat-status", getSeatStatus(desk, seatNum)])
                          }, _toDisplayString(getSeatStatus(desk, seatNum) === 'reserved' ? '已预约' : '游戏中'), 3),
                          (getSeatStatus(desk, seatNum) === 'reserved')
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                size: "small",
                                type: "primary",
                                text: "",
                                onClick: ($event: any) => (openSitDownDialog(desk, seatNum))
                              }, {
                                default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                                  _createTextVNode("上桌", -1)
                                ]))]),
                                _: 1
                              }, 8, ["onClick"]))
                            : _createCommentVNode("", true),
                          (getSeatStatus(desk, seatNum) === 'playing')
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 1,
                                size: "small",
                                type: "danger",
                                text: "",
                                onClick: ($event: any) => (handleStandUp(desk, seatNum))
                              }, {
                                default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                                  _createTextVNode("离开", -1)
                                ]))]),
                                _: 1
                              }, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ], 64))
                  ], 2)
                }), 64))
              ])
            ]))
          }), 128)),
          (desktopList.value.length === 0 && !desktopLoading.value)
            ? (_openBlock(), _createBlock(_component_el_empty, {
                key: 0,
                description: "暂无桌面"
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, "候桌列表 (" + _toDisplayString(waitingList.value.length) + "人)", 1),
            _createElementVNode("div", _hoisted_24, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(waitingList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "waiting-item"
                }, [
                  _createElementVNode("span", _hoisted_25, _toDisplayString(index + 1), 1),
                  _createVNode(_component_el_avatar, {
                    size: 24,
                    src: item.userInfo?.avatar ? getFullUrl(item.userInfo.avatar) : ''
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.userInfo?.name ? item.userInfo.name.charAt(0) : '?'), 1)
                    ]),
                    _: 2
                  }, 1032, ["src"]),
                  _createElementVNode("span", _hoisted_26, _toDisplayString(item.userInfo?.name || '-'), 1),
                  _createElementVNode("span", _hoisted_27, _toDisplayString(item.userInfo?.phone || '-'), 1),
                  _createVNode(_component_el_button, {
                    size: "small",
                    type: "primary",
                    text: "",
                    onClick: ($event: any) => (openWaitingSitDownDialog(item))
                  }, {
                    default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                      _createTextVNode(" 上桌 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _cache[47] || (_cache[47] = _createElementVNode("h3", null, "待出餐订单", -1)),
          _createVNode(_component_el_badge, {
            value: pendingOrders.value.length,
            hidden: pendingOrders.value.length === 0
          }, null, 8, ["value", "hidden"]),
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_el_switch, {
              modelValue: soundEnabled.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((soundEnabled).value = $event)),
              "active-icon": _unref(Bell),
              "inactive-icon": _unref(MuteNotification),
              "inline-prompt": ""
            }, null, 8, ["modelValue", "active-icon", "inactive-icon"]),
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: handleManualOrder
            }, {
              default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                _createTextVNode(" 手动下单 ", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pendingOrders.value, (order) => {
            return (_openBlock(), _createElementBlock("div", {
              key: order.id,
              class: "order-card"
            }, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("span", _hoisted_33, _toDisplayString(order.seatInfo || '未知桌位'), 1),
                _createElementVNode("span", _hoisted_34, "订单号：" + _toDisplayString(order.id), 1)
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  (order.userInfo)
                    ? (_openBlock(), _createBlock(_component_el_avatar, {
                        key: 0,
                        size: 24,
                        src: order.userInfo.avatar ? getFullUrl(order.userInfo.avatar) : ''
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(order.userInfo.name ? order.userInfo.name.charAt(0) : '?'), 1)
                        ]),
                        _: 2
                      }, 1032, ["src"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_37, _toDisplayString(order.userInfo?.name || '-'), 1),
                  _createElementVNode("span", _hoisted_38, _toDisplayString(order.userInfo?.phone || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_39, [
                  (hasMoneyAmount(order.price))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_40, "¥ " + _toDisplayString(formatMoney(order.price)), 1))
                    : _createCommentVNode("", true),
                  (hasPointsAmount(order.pointsPrice))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(formatPoints(order.pointsPrice)) + " 积分", 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_42, _toDisplayString(getPayTypeName(order.payType)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.goods, (item, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: idx,
                    class: "goods-item"
                  }, [
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("span", _hoisted_45, _toDisplayString(item.name || '-'), 1),
                      _createElementVNode("span", _hoisted_46, "x" + _toDisplayString(item.count || 1) + " · " + _toDisplayString(getGoodsTotalDisplay(item)), 1)
                    ]),
                    (_unref(getGoodsSpecLines)(item).length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getGoodsSpecLines)(item), (specLine, specIdx) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: `${idx}-spec-${specIdx}`,
                              class: "goods-spec-line"
                            }, _toDisplayString(specLine), 1))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("span", _hoisted_49, _toDisplayString(order.createTime), 1),
                _createElementVNode("div", _hoisted_50, [
                  _createVNode(_component_el_button, {
                    size: "small",
                    onClick: ($event: any) => (handleCancelOrder(order))
                  }, {
                    default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                      _createTextVNode(" 取消订单 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_el_button, {
                    type: "success",
                    size: "small",
                    onClick: ($event: any) => (handleComplete(order))
                  }, {
                    default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                      _createTextVNode(" 完成出餐 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ]))
          }), 128)),
          (pendingOrders.value.length === 0 && !orderLoading.value)
            ? (_openBlock(), _createBlock(_component_el_empty, {
                key: 0,
                description: "暂无待出餐订单"
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: sitDownDialogVisible.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((sitDownDialogVisible).value = $event)),
      title: "上桌操作",
      width: "400px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (sitDownDialogVisible.value = false))
        }, {
          default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
            _createTextVNode("取消", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSitDown
        }, {
          default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
            _createTextVNode("确定", -1)
          ]))]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: sitDownForm.value,
          "label-width": "80px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "用户" }, {
              default: _withCtx(() => [
                (!sitDownForm.value.isReserved)
                  ? (_openBlock(), _createBlock(_component_el_select, {
                      key: 0,
                      modelValue: sitDownForm.value.userId,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((sitDownForm.value.userId) = $event)),
                      placeholder: "从候桌列表选择",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(waitingList.value, (w) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: w.id,
                            label: `${w.userInfo?.name || '-'} (${w.userInfo?.phone || '-'})`,
                            value: w.userId
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(sitDownForm.value.userName), 1))
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "扣除积分" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: sitDownForm.value.points,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((sitDownForm.value.points) = $event)),
                  min: 0,
                  style: {"width":"100%"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: waitingSitDlgVisible.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((waitingSitDlgVisible).value = $event)),
      title: "选择座位上桌",
      width: "400px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[9] || (_cache[9] = ($event: any) => (waitingSitDlgVisible.value = false))
        }, {
          default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
            _createTextVNode("取消", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleWaitingSitDown
        }, {
          default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
            _createTextVNode("确定", -1)
          ]))]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: waitingSitForm.value,
          "label-width": "80px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "用户" }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(waitingSitForm.value.userName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "选择桌子" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: waitingSitForm.value.desktopId,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((waitingSitForm.value.desktopId) = $event)),
                  placeholder: "选择桌子",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(desktopList.value, (d) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: d.id,
                        label: d.name,
                        value: d.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "选择座位" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: waitingSitForm.value.seatNumber,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((waitingSitForm.value.seatNumber) = $event)),
                  placeholder: "选择座位",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getAvailableSeats(waitingSitForm.value.desktopId), (n) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: n,
                        label: `${n}号座`,
                        value: n
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "扣除积分" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: waitingSitForm.value.points,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((waitingSitForm.value.points) = $event)),
                  min: 0,
                  style: {"width":"100%"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: depositDlgVisible.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((depositDlgVisible).value = $event)),
      title: "存积分审核",
      "z-index": 1000,
      width: "80vw",
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: depositList.value,
          style: {"min-height":"600px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "userInfo.name",
              label: "用户"
            }),
            _createVNode(_component_el_table_column, {
              prop: "userInfo.phone",
              label: "手机号"
            }),
            _createVNode(_component_el_table_column, {
              prop: "points",
              label: "积分数"
            }),
            _createVNode(_component_el_table_column, {
              prop: "createTime",
              label: "申请时间"
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              width: "150"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_button, {
                  type: "success",
                  size: "small",
                  onClick: ($event: any) => (handleApprove(row, 'approved'))
                }, {
                  default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                    _createTextVNode("通过", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, {
                  type: "danger",
                  size: "small",
                  onClick: ($event: any) => (handleApprove(row, 'rejected'))
                }, {
                  default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                    _createTextVNode("拒绝", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(_component_el_pagination, {
          "current-page": depositPage.value,
          "onUpdate:currentPage": _cache[11] || (_cache[11] = ($event: any) => ((depositPage).value = $event)),
          "page-size": 10,
          total: depositTotal.value,
          layout: "total, prev, pager, next",
          style: {"margin-top":"16px","justify-content":"flex-end"},
          onCurrentChange: fetchDepositList
        }, null, 8, ["current-page", "total"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: verifyCouponDlgVisible.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((verifyCouponDlgVisible).value = $event)),
      title: "核销券",
      width: "500px",
      "append-to-body": "",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-width": "80px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "券码" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_52, [
                  _createVNode(_component_el_input, {
                    modelValue: couponId.value,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((couponId).value = $event)),
                    placeholder: "请输入券码",
                    style: {"flex":"1"}
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: handleQueryCoupon,
                    loading: couponLoading.value
                  }, {
                    default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                      _createTextVNode("查询", -1)
                    ]))]),
                    _: 1
                  }, 8, ["loading"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (couponInfo.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
              _createVNode(_component_el_descriptions, {
                column: 1,
                border: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions_item, { label: "券名称" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(couponInfo.value.name), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "状态" }, {
                    default: _withCtx(() => [
                      (couponInfo.value.verifyTime)
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 0,
                            type: "info"
                          }, {
                            default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                              _createTextVNode("已核销", -1)
                            ]))]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_el_tag, {
                            key: 1,
                            type: "success"
                          }, {
                            default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                              _createTextVNode("未核销", -1)
                            ]))]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }),
                  (couponInfo.value.goods)
                    ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                        key: 0,
                        label: "商品信息"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_54, [
                            _createVNode(_component_el_image, {
                              src: couponInfo.value.goods.image ? getFullUrl(couponInfo.value.goods.image) : '',
                              fit: "cover",
                              style: {"width":"60px","height":"60px","border-radius":"4px"}
                            }, null, 8, ["src"]),
                            _createElementVNode("div", _hoisted_55, [
                              _createElementVNode("div", _hoisted_56, _toDisplayString(couponInfo.value.goods.name || '-'), 1),
                              _createElementVNode("div", _hoisted_57, _toDisplayString(couponInfo.value.goods.description || '-'), 1),
                              _createElementVNode("div", _hoisted_58, "¥ " + _toDisplayString(couponInfo.value.goods.price || '0'), 1)
                            ])
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (!couponInfo.value.verifyTime)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (couponInfo.value.goods)
                      ? (_openBlock(), _createBlock(_component_el_form, {
                          key: 0,
                          "label-width": "80px",
                          style: {"margin-top":"16px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, { label: "选择桌" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: verifyCouponForm.value.desktopId,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((verifyCouponForm.value.desktopId) = $event)),
                                  placeholder: "请选择桌",
                                  style: {"width":"100%"}
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(desktopList.value, (desktop) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: desktop.id,
                                        label: desktop.name,
                                        value: desktop.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "选择座位" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: verifyCouponForm.value.seatNumber,
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((verifyCouponForm.value.seatNumber) = $event)),
                                  placeholder: "请选择座位",
                                  style: {"width":"100%"}
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getAvailableSeats(verifyCouponForm.value.desktopId), (n) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: n,
                                        label: `${n}号座`,
                                        value: n
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_59, [
                      _createVNode(_component_el_button, {
                        type: "success",
                        size: "large",
                        onClick: handleVerifyCouponSubmit,
                        loading: verifyLoading.value
                      }, {
                        default: _withCtx(() => [...(_cache[59] || (_cache[59] = [
                          _createTextVNode(" 确认核销 ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["loading"])
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: withdrawDlgVisible.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((withdrawDlgVisible).value = $event)),
      title: "取积分审核",
      "z-index": 1000,
      width: "80vw",
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: withdrawList.value,
          style: {"min-height":"600px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "userInfo.name",
              label: "用户"
            }),
            _createVNode(_component_el_table_column, {
              prop: "userInfo.phone",
              label: "手机号"
            }),
            _createVNode(_component_el_table_column, {
              prop: "points",
              label: "积分数"
            }),
            _createVNode(_component_el_table_column, {
              prop: "createTime",
              label: "申请时间"
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              width: "150"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_button, {
                  type: "success",
                  size: "small",
                  onClick: ($event: any) => (handleApprove(row, 'approved'))
                }, {
                  default: _withCtx(() => [...(_cache[60] || (_cache[60] = [
                    _createTextVNode("通过", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, {
                  type: "danger",
                  size: "small",
                  onClick: ($event: any) => (handleApprove(row, 'rejected'))
                }, {
                  default: _withCtx(() => [...(_cache[61] || (_cache[61] = [
                    _createTextVNode("拒绝", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(_component_el_pagination, {
          "current-page": withdrawPage.value,
          "onUpdate:currentPage": _cache[17] || (_cache[17] = ($event: any) => ((withdrawPage).value = $event)),
          "page-size": 10,
          total: withdrawTotal.value,
          layout: "total, prev, pager, next",
          style: {"margin-top":"16px","justify-content":"flex-end"},
          onCurrentChange: fetchWithdrawList
        }, null, 8, ["current-page", "total"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: manualOrderDlgVisible.value,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((manualOrderDlgVisible).value = $event)),
      title: "手动下单",
      width: "90vw",
      "z-index": 1000,
      "append-to-body": "",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("div", _hoisted_61, [
            _createVNode(_component_el_form, {
              "label-width": "80px",
              size: "small"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "选择用户" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: manualOrderForm.value.userId,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((manualOrderForm.value.userId) = $event)),
                      filterable: "",
                      remote: "",
                      "reserve-keyword": "",
                      placeholder: "搜索手机号",
                      "remote-method": searchUsers,
                      loading: userSearchLoading.value,
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userOptions.value, (user) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: user.value,
                            label: user.label,
                            value: user.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "loading"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "选择桌" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: manualOrderForm.value.desktopId,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((manualOrderForm.value.desktopId) = $event)),
                      placeholder: "请选择桌",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderDeskList.value, (d) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: d.id,
                            label: d.name,
                            value: d.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("div", _hoisted_63, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryList.value, (cat, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: cat.id,
                    class: _normalizeClass(["category-item", { active: currentCategoryIdx.value === idx }]),
                    onClick: ($event: any) => (currentCategoryIdx.value = idx)
                  }, _toDisplayString(cat.name), 11, _hoisted_64))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_65, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredGoodsList.value, (goods) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: goods.id,
                    class: "goods-item"
                  }, [
                    _createVNode(_component_el_image, {
                      src: goods.image ? getFullUrl(goods.image) : '',
                      fit: "cover",
                      style: {"width":"50px","height":"50px","border-radius":"4px"}
                    }, null, 8, ["src"]),
                    _createElementVNode("div", _hoisted_66, [
                      _createElementVNode("div", _hoisted_67, _toDisplayString(goods.name), 1),
                      _createElementVNode("div", _hoisted_68, _toDisplayString(goods.description || ''), 1),
                      _createElementVNode("div", _hoisted_69, _toDisplayString(getGoodsUnitDisplay(goods)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_70, [
                      (getCartCount(goods.id) > 0)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            size: "small",
                            circle: "",
                            onClick: ($event: any) => (removeFromCart(goods))
                          }, {
                            default: _withCtx(() => [...(_cache[62] || (_cache[62] = [
                              _createTextVNode("-", -1)
                            ]))]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (getCartCount(goods.id) > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_71, _toDisplayString(getCartCount(goods.id)), 1))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_button, {
                        size: "small",
                        type: "primary",
                        circle: "",
                        onClick: ($event: any) => (addToCart(goods))
                      }, {
                        default: _withCtx(() => [...(_cache[63] || (_cache[63] = [
                          _createTextVNode("+", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_72, [
            _cache[68] || (_cache[68] = _createElementVNode("div", { class: "cart-title" }, "已选商品", -1)),
            _createElementVNode("div", _hoisted_73, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cartItems.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.cartKey,
                  class: "cart-item"
                }, [
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("span", _hoisted_75, _toDisplayString(_unref(getGoodsDisplayName)(item)), 1),
                    _createElementVNode("span", _hoisted_76, _toDisplayString(getGoodsTotalDisplay(item)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_77, [
                    _createVNode(_component_el_button, {
                      size: "small",
                      circle: "",
                      onClick: ($event: any) => (decreaseCartItem(item.cartKey))
                    }, {
                      default: _withCtx(() => [...(_cache[64] || (_cache[64] = [
                        _createTextVNode("-", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createElementVNode("span", _hoisted_78, "x" + _toDisplayString(item.count), 1),
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "primary",
                      circle: "",
                      onClick: ($event: any) => (increaseCartItem(item))
                    }, {
                      default: _withCtx(() => [...(_cache[65] || (_cache[65] = [
                        _createTextVNode("+", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]))
              }), 128)),
              (cartItems.value.length === 0)
                ? (_openBlock(), _createBlock(_component_el_empty, {
                    key: 0,
                    description: "暂无商品",
                    "image-size": 60
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_79, [
              _cache[66] || (_cache[66] = _createElementVNode("span", null, "合计：", -1)),
              (hasMoneyAmount(cartMoneyTotal.value))
                ? (_openBlock(), _createElementBlock("span", _hoisted_80, "¥" + _toDisplayString(cartMoneyTotal.value), 1))
                : _createCommentVNode("", true),
              (hasPointsAmount(cartPointsTotal.value))
                ? (_openBlock(), _createElementBlock("span", _hoisted_81, _toDisplayString(formatPoints(cartPointsTotal.value)) + " 积分", 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_el_form, {
              "label-width": "80px",
              size: "small",
              style: {"margin-top":"16px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "支付方式" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: manualOrderForm.value.payType,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((manualOrderForm.value.payType) = $event)),
                      placeholder: "请选择",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(manualPayTypeOptions.value, (option) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: option.value,
                            label: option.label,
                            value: option.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "实收金额" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: manualOrderForm.value.receivedAmount,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((manualOrderForm.value.receivedAmount) = $event)),
                      min: 0,
                      precision: 2,
                      disabled: !hasMoneyAmount(cartMoneyTotal.value),
                      style: {"width":"100%"}
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "备注" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: manualOrderForm.value.remark,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((manualOrderForm.value.remark) = $event)),
                      type: "textarea",
                      rows: 2,
                      placeholder: "可选"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_82, [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "large",
                loading: manualOrderLoading.value,
                onClick: submitManualOrder
              }, {
                default: _withCtx(() => [...(_cache[67] || (_cache[67] = [
                  _createTextVNode(" 提交订单 ", -1)
                ]))]),
                _: 1
              }, 8, ["loading"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(GoodsSpecSelectDialog, {
      visible: specDialogVisible.value,
      "onUpdate:visible": _cache[25] || (_cache[25] = ($event: any) => ((specDialogVisible).value = $event)),
      goods: specDialogGoods.value,
      "initial-selected-specs": specDialogSpecs.value,
      onConfirm: handleSpecDialogConfirm
    }, null, 8, ["visible", "goods", "initial-selected-specs"]),
    _createVNode(_component_el_dialog, {
      modelValue: adjustPointsDlgVisible.value,
      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((adjustPointsDlgVisible).value = $event)),
      title: "会员积分调整",
      width: "500px",
      "append-to-body": "",
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[30] || (_cache[30] = ($event: any) => (adjustPointsDlgVisible.value = false))
        }, {
          default: _withCtx(() => [...(_cache[72] || (_cache[72] = [
            _createTextVNode("取消", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          loading: adjustPointsLoading.value,
          onClick: submitAdjustPoints
        }, {
          default: _withCtx(() => [...(_cache[73] || (_cache[73] = [
            _createTextVNode("确定", -1)
          ]))]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-width": "80px",
          size: "default"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "选择用户" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: adjustPointsForm.value.userId,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((adjustPointsForm.value.userId) = $event)),
                  filterable: "",
                  remote: "",
                  "reserve-keyword": "",
                  placeholder: "搜索手机号",
                  "remote-method": searchUsersForPoints,
                  loading: adjustPointsSearchLoading.value,
                  style: {"width":"100%"},
                  onChange: handleSelectUserForPoints
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(adjustPointsUserOptions.value, (user) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: user.value,
                        label: user.label,
                        value: user.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "loading"])
              ]),
              _: 1
            }),
            (selectedUserInfo.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                  _createVNode(_component_el_avatar, {
                    size: 60,
                    src: selectedUserInfo.value.avatar
                  }, null, 8, ["src"]),
                  _createElementVNode("div", _hoisted_84, [
                    _createElementVNode("div", _hoisted_85, _toDisplayString(selectedUserInfo.value.name || '-'), 1),
                    _createElementVNode("div", _hoisted_86, _toDisplayString(selectedUserInfo.value.phone || '-'), 1),
                    _createElementVNode("div", _hoisted_87, [
                      _cache[69] || (_cache[69] = _createTextVNode("当前积分：", -1)),
                      _createElementVNode("span", _hoisted_88, _toDisplayString(selectedUserInfo.value.points), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, { label: "操作类型" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: adjustPointsForm.value.type,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((adjustPointsForm.value.type) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { value: "add" }, {
                      default: _withCtx(() => [...(_cache[70] || (_cache[70] = [
                        _createTextVNode("增加积分", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { value: "reduce" }, {
                      default: _withCtx(() => [...(_cache[71] || (_cache[71] = [
                        _createTextVNode("减少积分", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "积分值" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: adjustPointsForm.value.amount,
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((adjustPointsForm.value.amount) = $event)),
                  min: 1,
                  precision: 0,
                  style: {"width":"100%"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "原因" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: adjustPointsForm.value.reason,
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((adjustPointsForm.value.reason) = $event)),
                  type: "textarea",
                  rows: 3,
                  placeholder: "请输入调整原因"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})